export const RAMADAN_PASSING_THRESHOLD = 100;
export const DEFAULT_PASSING_THRESHOLD = 80;

export const getPassingThreshold = (isRamadanQuiz) =>
  isRamadanQuiz ? RAMADAN_PASSING_THRESHOLD : DEFAULT_PASSING_THRESHOLD;

export const hasPassedQuiz = (percentage, isRamadanQuiz) =>
  Number(percentage ?? 0) >= getPassingThreshold(isRamadanQuiz);
